
import { Component, ReactNode } from 'react';
import * as Weirwood from '@baidu/weirwood-sdk';
import weirwoodOptions from '../../../weirwood.json';
import CustomError from '@components/customError';
const options = {
    common: {
        // 只支持如下字符：英文字母(大小写)，数字(0-9)，下划线(_)，中划线(-)，点(.)，@符号
        buildid: weirwoodOptions.buildid,
        token: weirwoodOptions.token,
        ignoreUrls: [
            // 本地开发屏蔽错误发送
            'localhost',
            '127.0.0.1',
            // 开发环境，测试环境 屏蔽错误
            /bcc-bdbl.baidu.com:[0-9]{4}/,
            /bcc-\w*.baidu.com:[0-9]{4}/,
            /templatesLocal\/doctor.html/,
            /bcc-gzhxy.baidu.com:[0-9]{4}/
        ]
    },
    error: {
        collectWindowErrors: true,
        // promise异常
        collectUnhandledRejections: false,
        // 静态资源加载异常
        collectResourceLoadErrors: false,
    },
    perf: {
        // 性能数据PV日志会比较大，可以输入 sampleRate 进行采样，控制在 50 W左右
        sampleRate: 0.3,
        spa: true,
        history: true,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
            /bcc-bdbl.baidu.com:[0-9]{4}/,
            /bcc-\w*.baidu.com:[0-9]{4}/,
            /templatesLocal\/doctor.html/,
            /bcc-gzhxy.baidu.com:[0-9]{4}/
        ]
    }
};

let weirwood: any = null;
if (!['dev', 'rd'].includes(process.env.PROXY_ENV || '')) {
    weirwood = Weirwood.init(options);
}

interface ComponentProps {
    children: ReactNode;
}

export class WeirwoodErrorBoundary extends Component {

    state: {hasError: boolean} = { hasError: false };
    props: ComponentProps;
    constructor(props: ComponentProps) {
        super(props);
        this.props = props;
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: any) {
        weirwood.error.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            return <CustomError />;
        }
        return this.props.children;
    }
}
